import type { LocalImpressaoTablet, LojaAtualResponse } from '../api'

export const DESTINO_CHAMADO_KDS = '@KDS'

export function destinoChamadoConfigurado(loja: LojaAtualResponse | undefined): boolean {
  return loja?.configuracao.tabletLocalImpressaoConfigurado === true
}

export interface OpcaoDestinoChamado {
  value: string
  label: string
}

export function opcoesImpressora(locais: LocalImpressaoTablet[] | undefined): OpcaoDestinoChamado[] {
  return (locais ?? [])
    .map((l) => ({ value: (l.chave ?? '').trim(), label: `Impressora: ${(l.descricao ?? l.nome ?? '').trim()}` }))
    .filter((o) => o.value)
}

export function comValorSalvo(salvo: string, opcoes: OpcaoDestinoChamado[]): OpcaoDestinoChamado[] {
  if (!salvo || salvo === DESTINO_CHAMADO_KDS || opcoes.some((o) => o.value === salvo)) {
    return opcoes
  }

  return [{ value: salvo, label: salvo }, ...opcoes]
}

export function textoAjudaDestino(salvo: string, opcoes: OpcaoDestinoChamado[]): string {
  if (!salvo) {
    return 'Sem destino, o botão Chamar garçom não aparece no tablet nem no celular.'
  }
  if (salvo === DESTINO_CHAMADO_KDS) {
    return 'Só aparece no KDS que estiver aberto e com “Chamados do salão” marcado na engrenagem. Com o KDS fechado, o chamado se perde.'
  }
  if (opcoes.length === 0) {
    return 'Nenhuma impressora encontrada. Escolha KDS para o chamado aparecer na tela da cozinha.'
  }
  return 'Impressora onde o chamado sai. É da loja: não importa de qual mesa ou tablet o cliente chamou.'
}
